import React, { useEffect, useMemo, useState } from "react";
import GlobalWrapper from "../../../components/Wrapper/GlobalWrapper";
import { Paper, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";
import { useDispatch, useSelector } from "react-redux";
import { getEveningFoodList } from "../../../redux/features/foodSlice";
import EveningFoodBulkApprove from "../EveningFoodBulkApprove";
import DatePickerCustom from "../../../components/DatePicker/DatePickerCustom";
import dayjs from "dayjs";
import useResponsive from "../../../Hooks/useResponsive";
import GlobalSelectFieldWithoutFormikNew from "../../../components/mui/GlobalSelectFieldWithoutFormikNew";
import { eveningApprovalForAllUsers } from "../../../components/datagrid/evenigFoodApproval/eveningApprovalForAllUsers";

const foodApprovalStatuses = [
  { idNo: 1, valueNo: "Pending" },
  { idNo: 2, valueNo: "Approved" },
  { idNo: 3, valueNo: "Rejected" },
  { idNo: 4, valueNo: "All" },
];
const EveningFoodApprovalForAll = () => {
  const { loading, foodList } = useSelector((store) => store.food);

  const dispatch = useDispatch();
  const [checkedRowsIds, setCheckedRowsIds] = useState([]);
  const [selectedStatus, setSelectedStaus] = useState({});
  const [filteredFoodList, setFilteredFoodList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const smDown = useResponsive("down", "sm");
  useEffect(() => {
    dispatch(getEveningFoodList({ date: selectedDate }));
  }, [selectedDate]);
  const handleSelectionChange = (datas) => {
    setCheckedRowsIds(datas);
  };

  useEffect(() => {
    let filtered = [];
    if (selectedStatus?.id == 1) {
      filtered = foodList.filter((data) => data.food_approval_status == 0);
    } else if (selectedStatus?.id == 2) {
      filtered = foodList.filter((data) => data.food_approval_status == 1);
    } else if (selectedStatus?.id == 3) {
      filtered = foodList.filter((data) => data.food_approval_status == 2);
    } else {
      filtered = foodList;
    }
    setFilteredFoodList(filtered);
  }, [selectedStatus, foodList]);

  return (
    <GlobalWrapper
      title={"Evening Food Approval"}
      actions={
        <>
          {checkedRowsIds.length > 1 && (
            <EveningFoodBulkApprove
              checkedRowsIds={checkedRowsIds}
              upDateCall={getEveningFoodList({ date: selectedDate })}
              alwaysButtonEnabled={true}
            />
          )}
        </>
      }
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          mb: 2,
        }}
      >
        <Box>
          <DatePickerCustom
            value={dayjs(selectedDate)}
            setValue={(date) => setSelectedDate(date.format("YYYY-MM-DD"))}
            viewDetails={["year", "month", "day"]}
            error={false}
            fullWidth={true}
          />
        </Box>
        <GlobalSelectFieldWithoutFormikNew
          sx={{ width: "230px" }}
          keys={{ itemId: "idNo", itemValue: "valueNo" }}
          label={"Status"}
          data={foodApprovalStatuses}
          selectedDetails={selectedStatus}
          setChange={setSelectedStaus}
          fullWidth={true}
          // reset={resetGlobalSelectField}
        />
      </Box>

      <Paper>
        <Box sx={{ width: "100%" }}>
          <DataGrid
            loading={loading}
            components={{ Toolbar: CustomGridToolbar }}
            rows={filteredFoodList}
            columns={eveningApprovalForAllUsers}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 5,
                },
              },
            }}
            pageSizeOptions={[5]}
            checkboxSelection
            onSelectionModelChange={handleSelectionChange}
            disableRowSelectionOnClick
            getRowId={(row) => row.food_id}
            // getRowHeight={()=>"auto"}
            autoHeight
          />
        </Box>
      </Paper>
    </GlobalWrapper>
  );
};

export default EveningFoodApprovalForAll;
